import { ValidationError } from '../network/rest/models/ValidationError';
import { ResponseError } from '../network/rest/runtime';
import History from './History';

export default function ApiErrorHandler(e: unknown, isClient?: boolean): string {
    if (e instanceof ResponseError) {
        if (e.response.status === 401 && History.navigate && !isClient) {
            History.navigate('/admin/login');
        }
        e.response.json().then((err: { detail: string } | Array<ValidationError>) => {
            if ('detail' in err) {
                return err.detail;
            }
        });
    }

    console.error(e);
    return 'Something went wrong';
}
